import React from 'react';

const Logo = ({ src, alt, width = 60, height = 60 }) => (
  <img src={src} alt={alt} width={width} height={height} className="d-inline-block align-top" style={{padding:'5px', width:'70px', fontFamily:"'Inter', sans-serif"}} />
);

export default Logo;
